import { RouteLocationNormalized } from 'vue-router'
import router from '.'

export enum Routes {
  LOGIN = '/login',

  DASHBOARD = '/dashboard',
  DASHBOARD_SUBMENU = ':submenu',

  SALES = '/sales',
  RECAP = '/recap',
  CATALOG = '/catalog',
  CATALOG_GUIDED = '/catalog/guided',
  CATALOG_CATEGORY = '/catalog/category',
  CATALOG_CATEGORY_MOBILE = '/catalog/category-mobile',
  // CATALOG_IMAGE = '/catalog/image',
  STOCK = '/stock',

  CASH_CHECK = '/cash-check',

  DEPOSITS = '/deposits',
  DEPOSITS_LIST = '/deposits/list',

  PETTYCASH = '/petty-cash',
  PETTY_CASH_LIST = '/petty-cash/list',
  PETTYCASHV2 = '/petty-cash-v2',
  SALES_LIST = '/sales-list',
  LAYBY_LIST = '/layby-list',
  SALES_DETAIL = '/sales-detail/:id',

  PRICE_UPDATE = '/price-update',
  GIFT_CARD_BALANCE = '/gift-card-balance',

  CASH_CLOSING = '/cash-closing',

  CUSTOMERS = '/customers',
  CUSTOMERS_DETAIL = '/customers/:id',
  CUSTOMERS_TASKS = '/customers/:id/tasks',

  INITIATIVE = '/initiatives',
  INITIATIVE_SEARCH_CLIENT = '/initiatives/search',
  INITIATIVE_WELCOME = '/initiatives/welcome/:id',
  INITIATIVE_LIST = '/initiatives/list',
  CONVERSATIONS = '/conversations',
  LOOKBOOK = '/lookbook',
  ADD_LOOKBOOK = '/add-lookbook',

  REFUND_B2E = '/refund-b2e',
  SUSPENDED_CREDIT = '/suspended-credit',
  ALL_SUSPENDED_CREDITS = '/suspended-credit/all',
  SUSPENDED_CREDIT_PERFORMED_PAYMENTS = '/suspended-credit/payments',
  LAYBY = '/layby',
  USER = '/user',
  USERS = '/users',
  RETURNS = '/returns',
  RECAP_RETURNS = '/returns/recap-returns',
  BANKS = '/banks',
  TOOLS = '/tools',
  TASKS = '/tasks',
  NOTIFICATIONS = '/notifications',

  CALLBACK = '/callback',

  /**
   * A special route used to show an iframe pointing to pages exposed by the previous UI.
   */
  PREVIOUS_UI_PAGES = '/previous',
  ENDLESS_AISLE = '/endless-aisle',
}

export enum RoutesName {
  SALES_DETAIL = 'salesDetail',
  DASHBOARD_SUBMENU = 'dashboardSubmenu',
  CATALOG_GUIDED = 'guided',
  CATALOG_CATEGORY = 'category',
  CATALOG_CATEGORY_MOBILE = 'category-mobile',
}

/**
 * Checks if the current route matches the specified route path.
 * @param routePath - The route path to check against.
 * @param route - The route to check. Defaults to the current route.
 * @returns `true` if the route path matches the specified route, `false` otherwise.
 */
export function isRoute(
  routePath: Routes,
  route: RouteLocationNormalized = router.currentRoute.value,
) {
  return route.path === routePath
}

/**
 * An helper functions that tells if user is viewing the login page.
 * @param route An optional route on which we should perform the check
 */
export function isLoginPage(
  route: RouteLocationNormalized = router.currentRoute.value,
) {
  return isRoute(Routes.LOGIN, route) || isRoute(Routes.CALLBACK, route)
}

/**
 * An helper functions that tells if user is viewing the homepage/dashboard page.
 * @param route An optional route on which we should perform the check
 */
export function isDashboardPage(
  route: RouteLocationNormalized = router.currentRoute.value,
) {
  return isRoute(Routes.DASHBOARD, route)
}
